/**
 * A single Mindbody widget as stored on the building's service-booking
 * app-instance-config (set via company-admin). `embed` is the full snippet the
 * customer copied from their Mindbody dashboard and is injected verbatim; `id`/
 * `type` mirror the embed's data-widget-id / data-widget-type and let a utility
 * button target specific widgets via the `widgetId` query param.
 */
export interface MindbodyWidget {
  embed: string;
  id?: string;
  type?: string;
}

/**
 * GET /api/verticals/SERVICE_BOOKING/BUILDING/:buildingUuid/instance-config?adapterName=...
 * — the tenant-accessible read of the building's MBO service-booking instance config
 * (returns the same RO as the admin detail endpoint: config blob + owner company).
 */
export interface MindbodyInstanceConfigResponse {
  config?: {
    adapter?: string;
    widgets?: MindbodyWidget[];
    site_id?: number;
  };
  company?: {
    uuid?: string;
  };
}

// Adapter name of the Mindbody service-booking provider — disambiguates the MBO instance
// from any other service-booking instance on the building (e.g. Timekit).
export const MINDBODY_PROVIDER_ADAPTER = 'MindbodyProviderAdapter';

// `type` of a Mindbody registration (healcode) widget. Matched case-insensitively
// since widget types come through with inconsistent casing (e.g. "Appointments").
export const MINDBODY_REGISTRATION_WIDGET_TYPE = 'registrations';
